module.exports = __webpack_public_path__ + "static/media/沈阳新世纪家园别墅智能化供暖项目.8932144e.jpg";